import {
  RadioGroup,
  FormLabel,
  FormControl,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useState } from "react";
import "./QuizDetails.css";
import Swal from "sweetalert2";
import { BsFillEyeFill } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const QuizDetails = ({ quiz }) => {
  const [show, setShow] = useState(false);

  const { question, options, correctAnswer } = quiz;
  console.log(quiz);

  const answerCorrect = () => {
    Swal.fire("Congratulation !!", "Your Answer is Correct");
    console.log("hello");
  };

  // <Blogs correct={correct}></Blogs>;

  const answerWrong = () => {
    Swal.fire("Ops !!", "Your Answer is wrong");
    // <CartResult wrongAnswer={wrongAnswer}></CartResult>;
  };

  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  return (
    <div className="quiz-details row row-cols-1 m-md-5 m-2 p-2">
      <div>
        {/* show correct answer by using modal */}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <h5 className="text-primary">Correct Answer:</h5> {correctAnswer}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* ...Question and see correct answer... */}
        <h5 className="d-flex justify-content-between">
          <span>
            <span className="text-secondary fw-bold">Question:</span> {question}
          </span>
          <span>
            <Button
              className="btn-show-answer fs-5"
              variant="secondary"
              onClick={handleShow}
            >
              <BsFillEyeFill
                title="Click and See Correct Answer"
                className="fs-4"
              />
            </Button>
          </span>
        </h5>
        {/* ......select answer option..... */}
        <div>
          <FormControl>
            <FormLabel
              className="text-info fw-bold fs-5"
              id="demo-radio-buttons-group-label"
            >
              Answer:
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel
                onChange={
                  options[0] === correctAnswer ? answerCorrect : answerWrong
                }
                value={options[0]}
                control={<Radio />}
                label={options[0]}
              />
              <FormControlLabel
                onChange={
                  options[1] === correctAnswer ? answerCorrect : answerWrong
                }
                value={options[1]}
                control={<Radio />}
                label={options[1]}
              />
              <FormControlLabel
                onChange={
                  options[2] === correctAnswer ? answerCorrect : answerWrong
                }
                value={options[2]}
                control={<Radio />}
                label={options[2]}
              />
              <FormControlLabel
                onChange={
                  options[3] === correctAnswer ? answerCorrect : answerWrong
                }
                className={options[3]}
                value={options[3]}
                control={<Radio />}
                label={options[3]}
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
    </div>
  );
};

export default QuizDetails;
